export default __webpack_public_path__ + "static/media/logo.eb65e0d5.png";